import { render } from "./UploadDocument.vue?vue&type=template&id=65c7b64e&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"

import "./UploadDocument.vue?vue&type=style&index=0&id=65c7b64e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7b64e"]])

export default __exports__